import React from 'react';
import { Heart, Zap, Scissors, Shield } from 'lucide-react';

const ServiceCategoryOverview = () => {
  const services = [
    {
      icon: <Shield color="currentColor" className="text-teal-500" size={48} />,
      title: "General Dentistry",
      description: "Comprehensive care for your overall dental health and preventive treatments.",
      link: "/general"
    },
    {
      icon: <Zap color="currentColor" className="text-lime-500" size={48} />,
      title: "Cosmetic Dentistry",
      description: "Transform your smile with advanced aesthetic dental procedures.",
      link: "/cosmetic"
    },
    {
      icon: <Scissors color="currentColor" className="text-teal-500" size={48} />,
      title: "Surgical Procedures",
      description: "Expert surgical interventions for complex dental and oral health needs.",
      link: "/surgical"
    },
    {
      icon: <Heart color="currentColor" className="text-lime-500" size={48} />,
      title: "Specialized Care",
      description: "Tailored treatments addressing unique dental health requirements.",
      link: "/other"
    }
  ];

  return (
    <div className="relative bg-gradient-to-br from-teal-900 to-lime-900 py-16 overflow-hidden">
      {/* Animated SVG Background Inspired by Logo */}
      <div className="absolute inset-0 opacity-10">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 1440 320" 
          className="absolute bottom-0 left-0 right-0"
        >
          <path 
            fill="currentColor" 
            className="text-teal-500"
            d="M0,160 C240,220 480,260 720,240 C960,220 1200,160 1440,128 L1440,320 L0,320 Z"
          />
        </svg>
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 1440 320" 
          className="absolute top-0 left-0 right-0 transform rotate-180"
        >
          <path 
            fill="currentColor" 
            className="text-lime-500"
            d="M0,160 C240,220 480,260 720,240 C960,220 1200,160 1440,128 L1440,320 L0,320 Z"
          />
        </svg>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-lime-100 mb-4">
            Our Comprehensive Dental Services
          </h2>
          <p className="text-teal-100 max-w-2xl mx-auto">
            Pristine Smile offers a wide range of dental services tailored to meet your unique needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="bg-teal-50 
                         shadow-2xl 
                         rounded-xl 
                         overflow-hidden 
                         transform 
                         transition 
                         duration-500 
                         hover:scale-105 
                         hover:shadow-2xl 
                         border-2 
                         border-transparent 
                         hover:border-teal-500
                         group"
            >
              <div className="p-6 text-center relative">
                {/* Subtle Gradient Overlay */}
                <div className="absolute inset-0 opacity-10 group-hover:opacity-20 transition-opacity duration-300 bg-gradient-to-br from-teal-500 to-lime-500"></div>
                
                <div className="relative z-10">
                  <div className="mb-4 flex justify-center">
                    {service.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-teal-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-teal-800 mb-4">
                    {service.description}
                  </p>
                  <a 
                    href={service.link} 
                    className="inline-block px-4 py-2 
                               bg-teal-600 
                               text-white 
                               rounded-full 
                               hover:bg-lime-600 
                               transition 
                               duration-300 
                               transform 
                               hover:-translate-y-1 
                               hover:shadow-lg"
                  >
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceCategoryOverview;